export default __webpack_public_path__ + "static/media/IconCircleChecked.f9a36eef.svg";